import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy} from 'lodash';
import {Table, Card, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';

class CpdPartsSalesList extends Component {
  calculateUtility(sales, cost) {
    return parseFloat(sales - cost);
  }

  calculateMargin(sales, cost) {
    if (!sales) {
      return 0;
    }
    const utility = this.calculateUtility(sales, cost);
    return (utility / sales) * 100;
  }

  renderSales() {
    const {salesList} = this.props;
    if (!salesList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={7}>
            No hay ventas con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }
    return salesList.map((element, index) => {
      const utility = this.calculateUtility(
        element.totalSales,
        element.totalCost
      );
      const margin = this.calculateMargin(
        element.totalSales,
        element.totalCost
      );
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.origin}</Table.Cell>
          <Table.Cell textAlign='center'>{element.providerName}</Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(element.totalSales, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(element.totalCost, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {getNumericValue(margin, 2)}%
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(utility, 2)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {'$'}
            {getNumericValue(element.totalInventoryCost, 2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals() {
    const {loading, salesList} = this.props;
    const sales = sumBy(salesList, 'totalSales');
    const cost = sumBy(salesList, 'totalCost');
    const inventoryCost = sumBy(salesList, 'totalInventoryCost');

    if (loading || !salesList.length) {
      return null;
    }

    const margin = this.calculateMargin(sales, cost);
    const utility = this.calculateUtility(sales, cost);
    return (
      <Table.Footer>
        <Table.Row textAlign='center' className='totals-row'>
          <Table.HeaderCell textAlign='left' colSpan={2}>
            TOTAL
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>
            {'$'}
            {getNumericValue(sales, 2)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>
            {'$'}
            {getNumericValue(cost, 2)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>
            {getNumericValue(margin, 2)}
            {'%'}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>
            {'$'}
            {getNumericValue(utility, 2)}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='right'>
            {'$'}
            {getNumericValue(inventoryCost, 2)}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderLoaderOrSales() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderSales();
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Origen</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Proveedor</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Ventas</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Costo de Ventas
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Margen</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Utilidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Inventario</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderOrSales()}</Table.Body>

          {this.renderTotals()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partsSales.loading,
    'salesList': state.partsSales.list,
  };
};

export default connect(mapStateToProps, {})(CpdPartsSalesList);
